import { make } from 'vuex-pathify'
import axios from 'axios'
// import uuid from '@/helpers/uuid'
// import definitions from '@/data/definitions'
// import { AZURE_SEARCH_DEFAULT_AXIOS_CONFIG } from '@/config/azure-search'
// import { athleticsKeys, artsKeys, educationalKeys } from './keys.js'

const state = {
  school: null,
  offerings: []
}

export default {
  namespaced: true,

  state,

  mutations: make.mutations(state),

  actions: {
    ...make.actions(state),

    async getSchool({ state, commit }, abbreviation) {

      if (!abbreviation) return null

      const { data } = await axios.post(
        process.env.VUE_APP_GRAPHQL_ENDPOINT,
        {
          query: `
        query schools($abbreviation: String!) {
          offerings(order_by: { title: asc }) {
            id
            title
            acronym
            shortCode
            description
            categories {
              category {
                id
                title
              }
            }
          }
          organizations(
            order_by: { title: asc }
            where: {
              parentOrganizationId: { _is_null: false }
              abbreviation: { _eq: $abbreviation }
            }
          ) {
            # Identifiers
            id
            title
            abbreviation
            educationLevels
            gradeLevels
            schoolType
            feederOrganizations
            instructionTypes
            status

            # Design & Branding
            exteriorPhotoUrl
            logoImageUrl
            mascotImageUrl
            primaryColor
            secondaryColor
            tagline
            elevatorPitch
            mission
            vision

            # Contact Details
            website
            hours
            phone
            fax
            email
            address
            facebook
            instagram
            twitter
            yearFounded
            administrators

            # Enrollment
            enrollment
            openSeats

            # Location
            boundaryMapCoordinates
            location

            # Attributes
            uniqueOfferings
            awardsHonors
            offerings {
              offering {
                id
                title
                acronym
                shortCode
                description
                categories {
                  category {
                    id
                    title
                  }
                }
              }
            }
          }
        }
        `,
          variables: {
            abbreviation: abbreviation.toUpperCase()
          },
        }
      )

      // Update state
      if (data && data.data && data.data.organizations && data.data.organizations.length) {
        commit('SET_SCHOOL', data.data.organizations[0])
      }
      if (data && data.data && data.data.offerings) {
        commit('SET_OFFERINGS', data.data.offerings)
      }

      return null
    },
  },

  getters: {
    // definitions: (state) => {
    //   return state.offerings.map(o => {
    //     let categories = []
    //     if (artsKeys.includes(o.shortCode)) categories.push('arts-offering')
    //     if (athleticsKeys.includes(o.shortCode)) categories.push('athletic-offering')
    //     if (educationalKeys.includes(o.shortCode)) categories.push('educational-offering')

    //     return {
    //       ...o,
    //       categories
    //     }
    //   })
    // },
    schoolWithMetadata: (state, getters) => {
      if (!state.school) return null
      return {
          ...state.school,
          // contactListItems: getters.contactListItems,
          // uniqueOfferingsListItems: getters.uniqueOfferingsListItems,
          // educationalOfferingsListItems: getters.educationalOfferingsListItems,
          // athleticsOfferingsListItems: getters.athleticsOfferingsListItems,
          // artsOfferingsListItems: getters.artsOfferingsListItems,
          // awardsHonorsListItems: getters.awardsHonorsListItems,
          // feederSchoolsListItems: getters.feederSchoolsListItems,
          // numbersListItems: getters.numbersListItems
        }
    },

    // contactListItems: (state) => {
    //   if (!state.school) return []

    //   const baseItemProps = {
    //     iconSize: 'md',
    //     alignTop: true,
    //   }

    //   let items = []

    //   if (state.school.phone) {
    //     items.push({
    //       ...baseItemProps,
    //       icon: 'phone-alt',
    //       label: 'Phone',
    //       description: state.school.phone,
    //     })
    //   }

    //   if (state.school.email) {
    //     items.push({
    //       ...baseItemProps,
    //       icon: 'email',
    //       label: 'Email',
    //       description: `<a href="mailto:${state.school.email}">${state.school.email}</a>"`,
    //     })
    //   }

    //   if (state.school.website) {
    //     items.push({
    //       ...baseItemProps,
    //       icon: 'external',
    //       label: 'Website',
    //       description:`<a
    //       href="${state.school.website}"
    //       target="_blank">${state.school.website}</a>`
    //     })
    //   }

    //   if (state.school.hours) {
    //     items.push({
    //       ...baseItemProps,
    //       icon: 'hours-alt',
    //       label: 'Office Hours',
    //       description: state.school.hours,
    //     })
    //   }

    //   if (state.school.address_street1) {
    //     items.push({
    //       ...baseItemProps,
    //       icon: 'map',
    //       label: 'Address',
    //       description: `${state.school.address_street1} <br>${state.school.address_city}, ${state.school.address_state} ${state.school.address_zip} <br> <a
    //       href="https://portal.schoolsitelocator.com/apps/ssl/?districtcode=77078"
    //       target="_blank">View boundary map</a>`,
    //     })
    //   }

    //   return items
    // },

    // uniqueOfferingsListItems: (state) => {
    //   if (!state.school) return []

    //   const baseItemProps = {
    //     alignTop: true,
    //     actionable: false,
    //     condensed: true,
    //     checked: true
    //   }

    //   return state.school.uniqueOfferings.map(s => ({
    //     ...baseItemProps,
    //       description: s
    //   }))
    // },

    // educationalOfferingsListItems: (state, getters) => {
    //   if (!getters.definitions) return []

    //   const baseItemProps = {
    //     alignTop: true,
    //     actionable: false,
    //     condensed: true,
    //     checked: true
    //   }

    //   return getters.definitions
    //     .filter(def => def.categories && def.categories.includes('educational-offering'))
    //     .filter(m => state.school.offerings.map(o => o.offering.shortCode).includes(m.shortCode))
    //     .sort((a, b) => a.title > b.title ? 1 : b.title > a.title ? -1 : 0)
    //     .map(def => ({
    //       ...baseItemProps,
    //         label: def.title,
    //         description: def.description
    //     }))
    // },

    // athleticsOfferingsListItems: (state, getters) => {
    //   if (!getters.definitions) return []

    //   const baseItemProps = {
    //     alignTop: true,
    //     actionable: false,
    //     condensed: true,
    //     checked: true
    //   }

    //   return getters.definitions
    //     .filter(def => def.categories.includes('athletic-offering'))
    //     .filter(m => state.school.offerings.map(o => o.offering.shortCode).includes(m.shortCode))
    //     .sort((a, b) => a.title > b.title ? 1 : b.title > a.title ? -1 : 0)
    //     .map(def => ({
    //       ...baseItemProps,
    //         description: def.title,
    //     }))
    // },

    // artsOfferingsListItems: (state, getters) => {
    //   if (!getters.definitions) return []

    //   const baseItemProps = {
    //     alignTop: true,
    //     actionable: false,
    //     condensed: true,
    //     checked: true
    //   }

    //   return getters.definitions
    //     .filter(def => def.categories.includes('arts-offering'))
    //     .filter(m => state.school.offerings.map(o => o.offering.shortCode).includes(m.shortCode))
    //     .sort((a, b) => a.title > b.title ? 1 : b.title > a.title ? -1 : 0)
    //     .map(def => ({
    //       ...baseItemProps,
    //         description: def.title,
    //     }))
    // },

    // awardsHonorsListItems: (state) => {
    //   if (state.school && state.school.awardsHonors) {
    //     const baseItemProps = {
    //       alignTop: true,
    //       actionable: false,
    //       condensed: true,
    //       checked: true
    //     }
    //     return state.school.awardsHonors.map(s => ({
    //       ...baseItemProps,
    //         description: s
    //     }))
    //   }

    //   return []
    // },

    // feederSchoolsListItems: (state) => {
    //   if (state.school && state.school.feederOrganizations){
    //     const baseItemProps = {
    //       alignTop: true,
    //       actionable: false,
    //       condensed: true,
    //     }

    //     return state.school.feederOrganizations.map(s => ({
    //       ...baseItemProps,
    //         description: s
    //     }))
    //   }
    //   return []


    // },

    // numbersListItems: (state) => {
    //   if (!state.school) return []

    //   const baseItemProps = {
    //     alignTop: true,
    //     actionable: false,
    //     condensed: true,
    //   }

    //   let items = []

    //   if (!!state.school.yearFounded) {
    //     items.push({
    //       ...baseItemProps,
    //       label: 'Year Founded',
    //       description: state.school.yearFounded + ''
    //     })
    //   }
    //   if (!!state.school.enrollment) {
    //     items.push({
    //       ...baseItemProps,
    //       label: 'Students',
    //       description: state.school.enrollment + ''
    //     })
    //   }

    //   return items
    // }
  }
}
